module.exports = __webpack_public_path__ + "img/robVol.473c8c60.png";